import React from 'react';

const SuccessNotification = () => {
    return (
        <svg width={22.301} height={17.408} viewBox="0 0 22.301 17.408">
            <path
                d="M20.886 1.414L5.908 16.408l-4.494-4.494"
                fill="none"
                stroke="#fafafa"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            />
        </svg>
    );
};

export default SuccessNotification;
